import { inject, Injectable } from '@angular/core';
import { LocumsMarginCalculatorEvents } from 'src/app/recruiting/locums-margin-calculator/store/enums/locums-margin-calculator-events';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { JobEffects } from 'src/app/recruiting/locums-margin-calculator/store/effects/job.effects';
import { CandidateEffects } from 'src/app/recruiting/locums-margin-calculator/store/effects/candidate.effects';
import { AdditionalRatesEffects } from 'src/app/recruiting/locums-margin-calculator/store/effects/additional-rates.effects';
import { MarginExpensesEffects } from './margin-expenses.effects';

@Injectable({ providedIn: 'root' })
export class MarginCalculatorEffects {
    private readonly jobEffects = inject(JobEffects);
    private readonly candidateEffects = inject(CandidateEffects);
    private readonly additionalRatesEffects = inject(AdditionalRatesEffects);
    private readonly eventBus = inject(EventBusService);
    private readonly marginExpensesEffects = inject(MarginExpensesEffects);

    constructor() {
        this.listenToLocums1099MarginCalculatorPageOpenedEvent();
    }

    private listenToLocums1099MarginCalculatorPageOpenedEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.LOCUMS_1099_MARGIN_CALCULATOR_PAGE_OPENED)
            .subscribe((event: EventPayload) => {
                this.jobEffects.loadJobDetails(event.payload.jobId);
                this.candidateEffects.loadCandidateDetails(event.payload.candidateId);
                this.additionalRatesEffects.getAdditionalRateTypes();
                this.additionalRatesEffects.getMarginCoverageTypes();
                this.marginExpensesEffects.loadMarginExpenseTypes();
            });
    }
}
